import {SVGProps} from 'react';

export const StopSquare = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  const iconFill = 'currentColor';
  return (
    <svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden {...props}>
      <rect width="12" height="12" rx="1.5" fill={iconFill} />
    </svg>
  );
};
